import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import QuoteModal from '@/components/QuoteModal';
import SocialMedia from '@/components/SocialMedia';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [showQuoteModal, setShowQuoteModal] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Ana Sayfa' },
    { path: '/kurumsal', label: 'Kurumsal' },
    { path: '/hizmetlerimiz', label: 'Hizmetlerimiz' },
    { path: '/projelerimiz', label: 'Projelerimiz' },
    { path: '/sss', label: 'SSS' },
    { path: '/iletisim', label: 'İletişim' },
  ];

  return (
    <>
      <nav
        data-testid="main-navbar"
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-white/90 backdrop-blur-sm'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            <Link to="/" data-testid="logo-link" className="flex items-center">
              <img
                src="https://customer-assets.emergentagent.com/job_cd45e30f-e731-4321-aacb-25f326987cc4/artifacts/m0s5scs4_Miga%20yap%C4%B1%20vekt%C3%B6rel%20mavi.png"
                alt="MİGA Yapı"
                className="h-12 w-auto"
                data-testid="logo-image"
              />
            </Link>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                  className={`text-sm font-medium transition-colors hover:text-[#dc2626] ${
                    location.pathname === link.path
                      ? 'text-[#dc2626]'
                      : 'text-gray-700'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <SocialMedia />
              <Button
                onClick={() => setShowQuoteModal(true)}
                data-testid="quote-button-desktop"
                className="bg-[#dc2626] hover:bg-[#b91c1c] text-white px-6 py-2 rounded-full font-medium transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                Teklif Al
              </Button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsOpen(!isOpen)}
              data-testid="mobile-menu-button"
              className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            >
              {isOpen ? <X className="h-6 w-6 text-gray-700" /> : <Menu className="h-6 w-6 text-gray-700" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div
          data-testid="mobile-menu"
          className={`md:hidden transition-all duration-300 ease-in-out overflow-hidden ${
            isOpen ? 'max-h-[600px] opacity-100' : 'max-h-0 opacity-0'
          }`}
        >
          <div className="px-4 pt-2 pb-6 space-y-3 bg-white/95 backdrop-blur-md border-t border-gray-100">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                data-testid={`mobile-nav-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                className={`block px-4 py-2 rounded-lg transition-colors ${
                  location.pathname === link.path
                    ? 'bg-[#dc2626] text-white'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Button
              onClick={() => {
                setShowQuoteModal(true);
                setIsOpen(false);
              }}
              data-testid="quote-button-mobile"
              className="w-full bg-[#dc2626] hover:bg-[#b91c1c] text-white py-2 rounded-full font-medium transition-all duration-300"
            >
              Teklif Al
            </Button>
            
            {/* Social Media - Mobile */}
            <div className="flex justify-center items-center gap-6 pt-4 border-t border-gray-200">
              <SocialMedia />
            </div>
          </div>
        </div>
      </nav>

      <QuoteModal open={showQuoteModal} onOpenChange={setShowQuoteModal} />
    </>
  );
};

export default Navbar;